import ky from "ky";
import { lastChange } from "./stores.js";
import { isAfter, parseISO, isValid } from "date-fns";

const OLD_BASE_URL = "https://sa-korona-api.herokuapp.com/covid/";
const MSIS_BASE_URL = "https://editorial.aftenbladet.no/korona-msis-api";

export const getCases = async () => {
	return await fetchData({
		endpoint: "municipalities",
		baseUrl: MSIS_BASE_URL,
		dataPath: "data",
		lastUpdatePath: "lastImport",
	});
};

export const getMunicipalityCases = async (kommune) => {
	return await fetchData({
		endpoint: `municipalitie/${kommune}`,
		baseUrl: MSIS_BASE_URL,
		dataPath: "data",
		lastUpdatePath: "lastImport",
	});
};

export const getAllMunicipalities = async () => {
	return await fetchData({
		endpoint: "all/municipalities",
		baseUrl: MSIS_BASE_URL,
		dataPath: "data",
		lastUpdatePath: "lastImport",
	});
};

export const getSUS = async () => {
	return await fetchData({
		endpoint: "sus",
		baseUrl: MSIS_BASE_URL,
		lastUpdatePath: "last.imported",
	});
};

export const getVaccination = async () => {
	return await fetchData({
		endpoint: "vaccination",
		baseUrl: MSIS_BASE_URL,
		lastUpdatePath: "imported",
	});
};

export const getCovidArticles = async () => {
	const articles = await ky(
		"https://iris-sa.schibsted.tech/v1/pages/collections?tags=5b091d23-db7e-4090-adfe-b331e43fa43d"
	).json();
	return articles.items;
};

/**
 *  Fetche and update the update time.
 * @param {{endpoint :string; baseURL :MSIS_BASE_URL | OLD_BASE_URL; lastUpdatePath :string}} object Object with the following properties
 * @returns result from the API endpoint
 */
const fetchData = async ({ endpoint, baseUrl, lastUpdatePath, dataPath }) => {
	const data = getPropertyFromPath(
		await ky(`${baseUrl}/${endpoint}`).json(),
		dataPath
	);

	lastChange.subscribe((value) => {
		const date = getPropertyFromPath(
			data.length ? data[0] : data,
			lastUpdatePath
		);

		if (!value || isAfter(parseISO(date), new Date(value))) {
			lastChange.update(() => parseISO(date));
		}
	});
	return data;
};

/**
 * Get property from a path in a object
 * @param {Object} object the object you want to get property from
 * @param {string} path the path to the property you want
 * @returns property from path
 */
const getPropertyFromPath = (object, path) => {
	// console.log(path, object);
	if (!path || path == "" || object.length !== undefined) {
		return object;
	}

	let current = object;
	try {
		path.split(".").forEach((level) => {
			current = current[level];
		});
	} catch (error) {
		console.log("Error", path);
		console.log(error);
		return undefined;
	}
	return current;
};
